import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {
	RestoreNovaAgentVersionInput,
	RestoreNovaAgentVersionMutation,
} from './__generated__/RestoreNovaAgentVersionMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

// The caller (NovaStudioPage.tsx) always follows a successful restore with its own on-demand
// detail refetch to bring the working draft and version list forward — this mutation's own
// response only needs to identify the agent for Relay's by-id store merge, not carry the restored
// content itself.
const mutation = graphql`
	mutation RestoreNovaAgentVersionMutation($input: RestoreNovaAgentVersionInput!) {
		restoreNovaAgentVersion(input: $input) {
			agent {
				id
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<RestoreNovaAgentVersionInput>,
	onSuccess?: RelayOnCompleted<RestoreNovaAgentVersionMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation<RestoreNovaAgentVersionMutation>(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
